import { defineMessages } from 'react-intl';

export const i18n: {
	errorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorMessage: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	viewError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	viewErrorTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addMutationError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	deleteMutationError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	mutationErrorAction: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	errorTitle: {
		id: 'reactions.error.title.generic',
		defaultMessage: 'We couldn’t update the reaction',
		description: 'Generic error title for adding or removing a reaction',
	},
	errorMessage: {
		id: 'reactions.error.message.generic',
		description:
			'Generic error displayed when adding or removing a reaction fails for unhandled cases',
		defaultMessage:
			'If the problem persists, contact {atlassianSupportLink} or your space admin so they can troubleshoot the issue.',
	},
	viewError: {
		id: 'reactions.view.error',
		defaultMessage: 'Reactions failed to load',
		description: 'A message shown when an error occurs when rendering reactions',
	},
	viewErrorTooltip: {
		id: 'reactions.view.error.tooltip',
		defaultMessage: 'Refresh to try again',
		description: 'A message telling the user to refresh the page',
	},
	addMutationError: {
		id: 'reactions.mutation.add.error',
		defaultMessage: 'Couldn’t add reaction',
		description: 'Message informing the user that adding a reaction failed',
	},
	deleteMutationError: {
		id: 'reactions.mutation.delete.error',
		defaultMessage: 'Couldn’t delete reaction',
		description: 'Message informing the user that deleting a reaction failed',
	},
	mutationErrorAction: {
		id: 'reactions.mutation.error.action',
		defaultMessage: 'Try again',
		description: 'Clickable link for the user to try the failed action again',
	},
});
